<template>
  <v-container>
    <div class="main-wrapper"> 
      <div>
            <p> Login... </p>
        </div>

    </div>
   </v-container>
</template>

<script>
export default {
    name: 'Login',
    methods: {
        signin () {            
            console.log("LOGIN PAGE");
            this.$store.commit('login');
        }
    },
    mounted() {
        this.signin();
    }
}
</script>




<style scoped>
h3 {
    font-size: 1.75rem;
    margin-bottom: .5rem;
    font-family: inherit;
    font-weight: 500;
    line-height: 1.2;
    color: inherit;
}

.main-wrapper {
    margin-bottom: 2%;
    margin-left: 5%;
    margin-right: 5%;

}

</style>>